export default __webpack_public_path__ + "media/images/logo-dark-a5d5f98c8d07af814cf1d07b228241a9.svg";